import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from './examMetricsActionType';
import * as actions from './examMetricsActions';
import * as services from './examMetricsService';

function* fetchExamMetricsMatrixSaga(action) {
	try {
		const response = yield call(services.getExamDataMatrixPagination, action.payload);
		if (!response) {
			throw new Error('No response received from matrix API');
		}

		yield put(actions.fetchExamMetricsMatrixSuccess(response?.values || {}));
	} catch (error) {
		yield put(actions.fetchExamMetricsMatrixFailure(error?.response?.data || 'Failed to fetch exam metrics matrix data.'));
	}
}

function* fetchExamMetricsDropdownSaga() {
	try {
		const response = yield call(services.getAllExamDataMatrixDropDown);
		if (!response) {
			throw new Error('No response received from dropdown API');
		}

		yield put(actions.fetchExamMetricsDropdownSuccess(response?.values || {}));
	} catch (error) {
		yield put(actions.fetchExamMetricsDropdownFailure(error?.response?.data || 'Failed to fetch exam metrics dropdowns.'));
	}
}

function* fetchExamMetricsDateRangeSaga() {
	try {
		const response = yield call(services.getLatestExamDateRange);
		if (!response) {
			throw new Error('No response received from latest date range API');
		}

		yield put(actions.fetchExamMetricsDateRangeSuccess(response?.values || {}));
	} catch (error) {
		yield put(actions.fetchExamMetricsDateRangeFailure(error?.response?.data || 'Failed to fetch latest exam metrics date range.'));
	}
}

export default function* watchExamMetricsSaga() {
	yield takeEvery(types.FETCH_EXAM_METRICS_MATRIX_REQUEST, fetchExamMetricsMatrixSaga);
	yield takeEvery(types.FETCH_EXAM_METRICS_DROPDOWN_REQUEST, fetchExamMetricsDropdownSaga);
	yield takeEvery(types.FETCH_EXAM_METRICS_DATE_RANGE_REQUEST, fetchExamMetricsDateRangeSaga);
}
